/**
 * Created by andermurias on 25/6/17.
 */
import React, {Component} from 'react';
import * as GoogleMapsLoader from 'google-maps';

import {mapStyle} from '../common/vars'

import '../../styles/elements/map.css';

import markersvg from '../../images/pages/contact/marker.png';

class Map extends Component {

    mapId = 'map-' + Math.round(Math.random()*100000);

    render() {
        return (
            <div className="map" id={this.mapId}></div>
        )
    }

    componentDidMount() {
        GoogleMapsLoader.KEY = 'AIzaSyCiKCifVOGR6pYq9RrBsj4Oy7DhB_blGa4';
        GoogleMapsLoader.LANGUAGE = 'en';
        GoogleMapsLoader.REGION = 'US';
        GoogleMapsLoader.load((google) => {
            let eutokia = {lat: 43.2478, lng: -2.9070};
            let map = new google.maps.Map(document.getElementById(this.mapId), {
                zoom: 17,
                center: eutokia,
                scrollwheel: false,
                navigationControl: false,
                mapTypeControl: false,
                scaleControl: true,
                draggable: true,
                styles: mapStyle
            });

            let markerIcon = {
                url: markersvg,
                scaledSize: new google.maps.Size(100, 100),
                /*
                origin: new google.maps.Point(0, 0), // used if icon is a part of sprite, indicates image position in sprite
                anchor: new google.maps.Point(-30,85) // lets offset the marker image*/
            };

            let eutokiaMarker = new google.maps.Marker({
                icon: markerIcon,
                position: eutokia,
                map: map
            });

            eutokiaMarker.addListener('click', function() {
                window.open('https://www.google.es/maps/place/EUTOKIA+-+Centro+de+Innovación+Social+de+Bilbao/');
            });

            google.maps.event.addListener(map, 'zoom_changed', function() {
                eutokiaMarker.setIcon(markerIcon);
            });
        })
    }


}

export default Map;






// WEBPACK FOOTER //
// ./src/js/elements/Map.js